"use client";

import { useCallback } from "react";
import { toast } from "react-toastify";

import { TOAST_OPTIONS } from "../offer-change-lang/vars";
import { ToastContent } from "./ToastContent";

export const useToastLowBalance = () => {
  const showToast = useCallback(() => {
    toast.info(({ closeToast }) => <ToastContent closeToast={closeToast} />, {
      ...TOAST_OPTIONS,
      toastId: "low-balance-toast",
    });
  }, []);

  return showToast;
};
